import { getApiBaseUrl } from '../utils/apiConfig.js';

const API_BASE_URL = getApiBaseUrl();
const THAI_API = `${API_BASE_URL}/thailand-arrival-card`;

export async function createThaiArrivalCard(payload) {
  const resp = await fetch(`${THAI_API}/applications`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ payload }),
    credentials: 'include',
  });

  const data = await resp.json().catch(() => ({}));
  if (!resp.ok) {
    throw new Error(data?.detail || '创建任务失败');
  }
  return data;
}

export async function getThaiArrivalCardStatus(taskId) {
  const resp = await fetch(`${THAI_API}/applications/${taskId}`, {
    credentials: 'include',
  });
  if (resp.status === 404) {
    throw new Error('任务不存在');
  }
  const data = await resp.json();
  if (!resp.ok) {
    throw new Error(data?.detail || '获取状态失败');
  }
  return data;
}

export async function listThaiArrivalCardTasks(limit = 20) {
  const resp = await fetch(`${THAI_API}/applications?limit=${limit}`, {
    credentials: 'include',
  });
  if (!resp.ok) {
    const data = await resp.json().catch(() => ({}));
    throw new Error(data?.detail || '获取任务列表失败');
  }
  return resp.json();
}

export async function getThaiCountries() {
  const resp = await fetch(`${THAI_API}/countries`, {
    credentials: 'include',
  });
  const data = await resp.json().catch(() => ({}));
  if (!resp.ok) {
    throw new Error(data?.detail || '获取国家列表失败');
  }
  return data;
}

export async function getThaiProvinces() {
  const resp = await fetch(`${THAI_API}/provinces`, {
    credentials: 'include',
  });
  const data = await resp.json().catch(() => ({}));
  if (!resp.ok) {
    throw new Error(data?.detail || '获取省份列表失败');
  }
  return data;
}
